/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useState, useEffect } from 'react';
import PatientFilterModal from "./PatientFilterModal";
import ComplaintFilterModal from './ComplaintFilterModal';
import DiagnosisFilterModal from './DiagnosisFilterModal';
import LabFilterModal from './LabFilterModal';
import DrugFilterModal from './DrugFilterModal';
import OtherFilterModal from './OtherFilterModal';


const CategoryTabs = ({ handleFilters, selectedFilters, symptomsCategoryList, selectedCategoryId, setSelectedCategoryId, selectedCategoryType, setSelectedCategoryType, diagnosisEnlarge, setDiagnosisEnlarge, diagnosisCategoryList, handleDiagnosisType, labTestList, treatments, starStatusList }) => {
    const [showPatientModal, setShowPatientModal] = useState(false);
    const [showComplaintsModal, setShowComplaintsModal] = useState(false);
    const [showDiagnosisModal, setShowDiagnosisModal] = useState(false)
    const [showLabModal, setShowLabModal] = useState(false)
    const [showDrugModal, setShowDrugModal] = useState(false)
    const [showOtherFilterModal, setShowOtherFilterModal] = useState(false)





    const closePatientModal = (filters) => {
        setShowPatientModal(false)
        if (Array.isArray(filters) && filters)
            handleFilters("Patient", filters)
    }

    const closeComplaintModal = () => {
        setShowComplaintsModal(false)
        setSelectedCategoryId(localStorage.getItem("clinicId"))
        setSelectedCategoryType("clinic")
    }

    const handleSaveComplaintsFilter = (filters) => {
        setShowComplaintsModal(false)
        if (Array.isArray(filters) && filters)
            handleFilters("Complaint", filters)
    }

    const closeDiagnosisModal = () => {
        setShowDiagnosisModal(false)
        setDiagnosisEnlarge({
            type: "longTerm",
            diagnosisCategoryId: localStorage.getItem("clinicId"),
            longTermArr: [],
            interCurrentArr: [],
        })
    }

    const handleSaveDiagnosisFilter = (filters) => {
        console.log(filters, "ppppppppppppppppppp")
        setShowDiagnosisModal(false)
        if (Array.isArray(filters) && filters)
            handleFilters("Diagnosis", filters)
    }

    const closeLabModal = (filters) => {
        setShowLabModal(false)
        if (Array.isArray(filters) && filters)
            handleFilters("LabTest", filters)
    }

    const closeDrugModal = (filters) => {
        setShowDrugModal(false)
        if (Array.isArray(filters) && filters)
            handleFilters("Drug", filters)
    }

    const closeOtherFilterModal = (filters) => {
        setShowOtherFilterModal(false)
        if (Array.isArray(filters) && filters)
            handleFilters("Other", filters)
    }




    return (
        <div className="category-container">
            <button className="category-tab" onClick={(e) => setShowPatientModal(true)}>Patient</button>
            <button className="category-tab" onClick={(e) => setShowComplaintsModal(true)}>Complaint</button>
            <button className="category-tab" onClick={(e) => setShowDiagnosisModal(true)}>Diagnosis</button>
            <button className="category-tab" onClick={(e) => setShowLabModal(true)}>Investigation</button>
            <button className="category-tab" onClick={(e) => setShowDrugModal(true)}>Medicine</button>
            <button className="category-tab" onClick={(e) => setShowOtherFilterModal(true)}>Others</button>
            {showPatientModal &&
                <PatientFilterModal show={showPatientModal} handleClose={(filters) => closePatientModal(filters)} filters={selectedFilters["Patient"]} starStatusList={starStatusList} />
            }
            {showComplaintsModal &&
                <ComplaintFilterModal showModal={showComplaintsModal} handleClose={(filters) => closeComplaintModal(filters)} filters={selectedFilters["Complaint"]} symptomsCategoryList={symptomsCategoryList} selectedCategoryId={selectedCategoryId} setSelectedCategoryId={setSelectedCategoryId} selectedCategoryType={selectedCategoryType} setSelectedCategoryType={setSelectedCategoryType} handleSaveComplaintsFilter={(filters) => handleSaveComplaintsFilter(filters)} />
            }
            {showDiagnosisModal &&
                <DiagnosisFilterModal showDiagnosisModal={showDiagnosisModal} handleClose={closeDiagnosisModal} diagnosisEnlarge={diagnosisEnlarge} setDiagnosisEnlarge={setDiagnosisEnlarge} diagnosisCategoryList={diagnosisCategoryList} handleDiagnosisType={handleDiagnosisType}
                    handleSaveDiagnosisFilter={(filters) => handleSaveDiagnosisFilter(filters)} filters={selectedFilters["Diagnosis"]} />
            }
            {showLabModal &&
                <LabFilterModal show={showLabModal} labTestList={labTestList} handleClose={(filters) => closeLabModal(filters)} filters={selectedFilters["LabTest"]} />
            }
            {showDrugModal &&
                <DrugFilterModal showModal={showDrugModal} handleClose={(filters) => closeDrugModal(filters)} filters={selectedFilters["Drug"]} />
            }
            {
                showOtherFilterModal &&
                <OtherFilterModal showModal={showOtherFilterModal} handleClose={(filters) => closeOtherFilterModal(filters)} treatments={treatments} filters={selectedFilters["Other"]} />
            }
        </div>
    );
};

export default CategoryTabs;
